import { DetailsFormFieldProps, FormattingDisplayProps, SearchInputProps } from "models/propTypes/wintFormPropsTypes";
import DetailsFormBaseField from "./detailsFormBaseField";
import FormattingDisplay from "../formDisplays/formattingDisplay";
import SearchInput from "../formFields/searchInput";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";

const SearchField = (
  props: SearchInputProps & Omit<FormattingDisplayProps<AutocompleteListItem>, "formatter"> & DetailsFormFieldProps
) => {
  return (
    <DetailsFormBaseField<SearchInputProps, FormattingDisplayProps<AutocompleteListItem>>
      Display={FormattingDisplay}
      Input={SearchInput}
      {...props}
      formatter={(value) => value.value as string}
    />
  );
};

export default SearchField;
